/**
 * @exports ClientChart
 * @fileoverview this file define the LineChart component 
 * @date 2022-08-23
 * @version 1.0 
 * @author Combes Hugo
 */


/*Import necessaries librairies*/
import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';
import {Chart, ArcElement, Tooltip, Legend} from 'chart.js'
import {CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title} from 'chart.js'
Chart.register(ArcElement, Tooltip, Legend, CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title);
  
class ClientChart extends Component{
    render(){
      const labels = this.props.data[1]
      const datasets = []
      /**
       * @function pointFormBaseOnIndex
       * @brief for given int, return a string that is interpreted to change the form 
       * of point in the graph thx to the pointStyle option
       * @param {int} i, index of the graph (work as a pile, first in, last out) 
       * @returns {String} return a string that represent a form
       * @version 1.0
      */
      function pointFormBaseOnIndex(i){
        if (i===0) return ("circle")
        if (i===1) return ("crossRot")
        if (i===2) return ("rect")
        if (i===3) return ("triangle")
        if (i===4) return ("line")
        if (i===5) return ("cross")
        else return ("star")
      }



      const colorPalette = [] // 	slate blue
      for (let i = 0; i < this.props.data[0].length; i++){
        colorPalette[i]=[i*10 + Math.random()*155 , 120 + i*10 ,205]
      }
      if(this.props.data[3]){
        if(this.props.data[3] === "chartTypologie"){
          colorPalette[0] = ['54','162','235']
          colorPalette[1] = ['255','99','132']
          colorPalette[2] = ['255','206','86']
          colorPalette[3] = ['75','192','192']
        }
      }
      
      for(let i = 0; i < this.props.data[0].length; i++){
        datasets.push(
          {
            label: this.props.data[0][i],
            data: this.props.data[2][i],
            borderColor: 'rgb('+ colorPalette[i][0] +','+ colorPalette[i][1] + ','+  colorPalette[i][2]  +')',
            backgroundColor: 'rgba('+ colorPalette[i][0] +','+ colorPalette[i][1] + ','+   colorPalette[i][2]   +', 0.5)',
            pointStyle: pointFormBaseOnIndex(i),
            radius:4,
          },
        )

      }

      const options = {
        plugins:{
          legend:{
            labels:{ usePointStyle:true, },
          },
        },
      }

      const data = {
        fill:true,
        labels,
        datasets
      };

      return (
        <div >
          <Line data={data} options={options} />
        </div>
      )
    }
  }
  
  export default ClientChart;
